import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';  // Importando o CSS do Bootstrap
import './TabComponent.css';

// Importar componentes de páginas
import { useNavigate } from 'react-router-dom';

const TabComponent = () => {
  const navigate = useNavigate();  // Hook para navegação
  const [activeTab, setActiveTab] = useState('checkin');  // Estado para gerenciar a aba ativa

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Navegar para a rota correspondente quando a aba for clicada
    if (tab === 'checkin') {
      navigate('/');
    } else if (tab === 'buscar') {
      navigate('/buscar');
    } else if (tab === 'area-restrita') {
      navigate('/area-restrita');
    }
  };

  return (
    <div className="d-flex flex-column" style={{ height: '100vh' }}>

      {/* Abas fixadas na parte inferior */}
      <ul className="nav nav-pills justify-content-center mb-3 fixed-bottom">
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === 'checkin' ? 'active' : ''}`}
            onClick={() => handleTabChange('checkin')}
          >
            Checkin
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === 'buscar' ? 'active' : ''}`}
            onClick={() => handleTabChange('buscar')}
          >
            Buscar
          </a>
        </li>
        <li className="nav-item">
          <a
            className={`nav-link ${activeTab === 'area-restrita' ? 'active' : ''}`}
            onClick={() => handleTabChange('area-restrita')}
          >
            Área Restrita
          </a>
        </li>
      </ul>
    </div>
  );
};

export default TabComponent;
